import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import {
  replace as replaceURL,
  push as changeURL
} from 'react-router-redux';

import mapDispatch from '~/misc/mapDispatch';
import store from '~/store';
import {modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';
import {getHpInfo, getHpPlanInfo, getBuyerInfo} from '~/modules/hp/actions';
import Spinner from '~/components/common/Spinner';
import {getUrlQeury} from '~/misc/formatUrlquery';
import {track} from '~/misc/metrics';

import css from './index.css';
import sharedCSS from '~/components/shared.css';
import accountPageCss from '../MyAccount/share.css';

class PaymentProcess extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      navItem: [
        {
          routing: '/hp',
          name: 'Basic Information',
          active: false,
        },
        {
          routing: '/hp/product-selection',
          name: 'Product Selection',
          active: false,
        },
        {
          routing: '/hp/billing-information',
          name: 'Billing Information',
          active: false,
        },
        {
          routing: '/hp/payment',
          name: 'Payment',
          active: false,
        },
      ],
      formData: {
        step1: {},
        step2: {},
        step3: {},
        step4: {},
      },
      query: {},
    };
  }

  componentWillMount() {
    // 来源埋点
    const query = getUrlQeury();
    if (!isEmpty(query) && query.from) {
      track('payment', {source: query.from});
    };
    this.setState({
      query: query
    });
    // this.props.gotoRoot();
    // 已经登录用户进页面逻辑
    if (this.props.user.id
      && this.props.account.userInfo.data
      && this.props.account.userInfo.data.memberPlan
    ) {
      this.getPageInfo(query.level);
    }
  }

  componentDidMount() {
    const token = this.props.user.token;
    if (!token) {
      store.dispatch(modalChange(modes.LOGIN, 'hp'));
    }
  }

  componentWillReceiveProps(nextProps) {
    // 解决当前页面登出后数据不更新的问题，
    if (this.props.user.id && (this.props.user.id !== nextProps.user.id)) {
      this.setState({
        step: 1,
        navItem: [
          {
            routing: '/hp',
            name: 'Basic Information',
            active: false,
          },
          {
            routing: '/hp/product-selection',
            name: 'Product Selection',
            active: false,
          },
          {
            routing: '/hp/billing-information',
            name: 'Billing Information',
            active: false,
          },
          {
            routing: '/hp/payment',
            name: 'Payment',
            active: false,
          },
        ],
        formData: {
          step1: {},
          step2: {},
          step3: {},
          step4: {},
        },
      });
      setTimeout(this.props.gotoRoot(), 0);
    }

    if (!this.props.account.userInfo.data
      && nextProps.account.userInfo.data
    ) {
      this.getPageInfo()
    }

    // 如果已经登陆的会员账号，直接进入首页。否则进入会员购买页。
    const {user, account} = nextProps;

    // Jumping to loads page when user had already be a pro user.
    if (nextProps.user.token && nextProps.account.accountLevel > 3) {
      this.props.gotoLoads();
    }

    // 已经是会员且跳转过来想要购买的会员级别和当前拥有的级别相同 跳回loads页面
    if (
      user.token
      && account.userInfo
      && account.userInfo.data
      && account.userInfo.data.memberPlan
      && account.userInfo.data.memberPlan.toLocaleLowerCase() == this.state.query.level
    ) {
      this.props.gotoLoads();
    }
  }

  render() {
    return (
      <div className={cs(sharedCSS.widewrap, 'qa-content')}>
        <div className={cs(sharedCSS.wideStretchable, css.wrap)}>
          <ul className={css.NavItem}>
            {this.state.navItem.map((item, index) => {
              if (item.active) {
                return (
                  <li key={index} className={css.choosen}>
                    {(index !== 0) && <span className={css.dot}>. . .</span>}
                    <span className={cs(css.icon, css.selectIcon)} />
                    <span className={css.breakWord}>{item.name}</span>
                  </li>
                );
              }
              if (index === 0) {
                return (
                  <li key={index} className={css.unchoose}>
                    <span className={css.icon}>{index + 1}</span>
                    <span className={css.breakWord}>{item.name}</span>
                  </li>
                );
              }
              return (
                <li key={index} className={css.unchoose}>
                  <span className={css.dot}>. . .</span>
                  <span className={css.icon}>{index + 1}</span>
                  <span className={css.breakWord}>{item.name}</span>
                </li>
              );
            })
            }</ul>
          <div>{this.renderContent()}</div>
        </div>
      </div>
    );
  }

  renderContent() {
    const token = this.props.user.token;
    const childrenWithProps = React.Children.map(
      this.props.children,
      (child) => React.cloneElement(
        child,
        {
          user: this.props.user,
          account: this.props.account,
          parentState: this.state,
          routing: this.props.routing,
          hp: this.props.hp,
          changeNavItem: (num) => this.changeNavItem(num),
          changeStep: (num) => this.changeStep(num),
          setStepData: (num, data) => this.setStepData(num, data),
        }
      )
    );
    const hpPlanInfo = this.props.hp.hpPlanInfo;
    const accountBuyerInfo = this.props.hp.accountBuyerInfo;

    if (!token) {
      return (
        <div className={cs(css.removeBg, css.center)}>
          please <span onClick={this.props.login}>login</span> or <span onClick={this.props.signup}>sign up</span>
        </div>
      );
    }

    // 会员套餐信息
    if (hpPlanInfo.error) {
      return (
        <div className={cs(css.viewH, css.center)} onClick={this.getPageInfo}>
          {hpPlanInfo.error}
        </div>
      );
    }

    if (!isEmpty(hpPlanInfo.data) && accountBuyerInfo.isGeted) {
      return (
        <div className={css.content}>{childrenWithProps}</div>
      );
    }

    return (
      <div className={css.viewH}>
        <div className={cs(accountPageCss.spinnerLine)}>
          <div className={cs(accountPageCss.spinner, css.marginCenter)}>
            <Spinner scalable={true}/>
          </div>
        </div>
      </div>
    );
  }

  getPageInfo(level) {
    const queryLevel = level ? level : this.state.query.level;
    // store.dispatch((dispatch, getState) => getHpInfo(dispatch, getState));
    store.dispatch((dispatch, getState) => getHpPlanInfo(dispatch, getState, queryLevel));
    store.dispatch((dispatch, getState) => getBuyerInfo(dispatch, getState));
  }

  changeStep(num) {
    return this.setState({
      step: num,
    });
  }

  changeNavItem(num) {
    const navItem = this.state.navItem;
    for (let i = 0; i < navItem.length; i++) {
      if (i < num) {
        navItem[i].active = true;
      } else {
        navItem[i].active = false;
      }
    }
    return this.setState({
      navItem: navItem,
    });
  }

  setStepData(num, formData) {
    const step = `step${ num}`;
    return this.setState({
      formData: {
        ...this.state.formData,
        [step]: formData,
      },
    });
  }
}

export default connect(({user, routing, account, hp}) => ({user, routing, account, hp}), mapDispatch({
  login: () => modalChange(modes.LOGIN, 'user-account'),
  signup: () => modalChange(modes.SIGNUP, 'user-account'),
  gotoRoot: () => changeURL('/hp'),
  gotoLoads: () => changeURL('/loads'),
}))(PaymentProcess);



// WEBPACK FOOTER //
// ./src/components/pages/PaymentProcess/index.js